// extracted by mini-css-extract-plugin
export default {"container":"consent_container__1ArFu","disabled":"consent_disabled__3LY-I","withoutStyle":"consent_withoutStyle__1j2_C"};